var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24993 12.4997C4.51119 12.5005 3.79812 12.2287 3.24734 11.7364C2.69655 11.2441 2.34677 10.5659 2.26502 9.83166C2.18326 9.09745 2.37528 8.3589 2.80428 7.75749C3.23329 7.15608 3.86911 6.7341 4.58993 6.5724C4.38137 5.59972 4.56775 4.58403 5.10807 3.74877C5.64838 2.9135 6.49838 2.32709 7.47106 2.11853C8.44374 1.90997 9.45943 2.09635 10.2947 2.63666C11.13 3.17698 11.7164 4.02697 11.9249 4.99965H11.9999C12.9299 4.99872 13.827 5.34337 14.5172 5.96668C15.2073 6.59 15.6413 7.44753 15.7347 8.37278C15.8282 9.29804 15.5745 10.225 15.0229 10.9738C14.4714 11.7225 13.6613 12.2396 12.7499 12.4247M11.2499 10.2497L8.99993 7.99966M8.99993 7.99966L6.74993 10.2497M8.99993 7.99966V16.9997",
    stroke: "#64748B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.b5a2e597f556ecc2384a6727a8467b24.svg";
export { ForwardRef as ReactComponent };